import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from './auth.service';

export const platformAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const decide = () => {
    if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
    return auth.isSuperAdmin() ? true : router.createUrlTree(['/']);
  };

  if (!auth.isLoading()) return decide();

  return toObservable(auth.isLoading).pipe(
    filter((loading) => !loading),
    take(1),
    map(() => decide()),
  );
};
